import BasicRouterView from "../../../components/BasicRouterView.vue";

const comprasSolicitante = {
  path: "cms",
  redirect: { name: "salvos" },
  meta: {
    label: "Compras - Solicitante",
    icon: "task",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "compra/criar-necessidades-solicitante",
      name: "compras-criar-necessidades-solicitante",
      meta: {
        label: "Criar Necessidade Solicitante",
        icon: "settings",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/CriarNecessidadeSolicitante.vue"
        ),
    },
    {
      path: "compra/listar-necessidades-solicitante",
      name: "compras-listar-necessidades-solicitante",
      meta: {
        label: "Listar Necessidade Solicitante",
        icon: "settings",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/ListarNecessidadeSolicitante.vue"
        ),
    },
    {
      path: "compra/compra-detalhe-versao-2/:id",
      name: "compras-detalhe-versao-2",
      meta: {
        label: "Compra Detalhe Versão 2",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/NecessidadeDetalheVersao2"
        ),
    },
    {
      path: "compra/detalhe-necessidade-manual/:id",
      name: "compras-detalhe-necessidade-manual",
      props: true,
      meta: {
        label: "Detalhe Necessidades Manuais",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/DetalheNecessidadeManual.vue"
        ),
    },
  ],
};

export default comprasSolicitante;
